import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=20d8a4ed&scoped=true"
import script from "./InputSearch.vue?vue&type=script&lang=js"
export * from "./InputSearch.vue?vue&type=script&lang=js"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=20d8a4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8a4ed",
  null
  
)

export default component.exports